<template>
	<Teleport to="body">
		<div v-if="visible" class="ov-modal-backdrop" @click.self="onBackdrop">
			<div class="ov-modal" role="dialog">
				<div class="ov-modal__header">
					<h3 class="ov-modal__title">{{ title }}</h3>
					<button type="button" class="ov-modal__close" @click="hide">&times;</button>
				</div>
				<div class="ov-modal__body">
					<slot />
				</div>
				<div v-if="showFooter" class="ov-modal__footer">
					<OvButton variant="ghost" :disabled="busy" @click="hide">Cancel</OvButton>
					<OvButton variant="primary" :disabled="busy" @click="$emit('ok')">Save</OvButton>
				</div>
			</div>
		</div>
	</Teleport>
</template>

<script>
import OvButton from "./OvButton.vue";

export default {
	name: "OvModal",
	components: { OvButton },
	props: {
		title: { type: String, default: "" },
		busy: { type: Boolean, default: false },
		showFooter: { type: Boolean, default: true },
	},
	emits: ["ok", "hidden"],
	data() {
		return { visible: false };
	},
	methods: {
		show() {
			this.visible = true;
		},
		hide() {
			this.visible = false;
			this.$emit("hidden");
		},
		onBackdrop() {
			if (!this.busy) {
				this.hide();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.ov-modal-backdrop {
	position: fixed;
	inset: 0;
	z-index: 1050;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(15, 23, 42, 0.45);
	padding: var(--ds-space-5);
}

.ov-modal {
	width: 100%;
	max-width: 520px;
	background: var(--ds-color-surface);
	border-radius: var(--ds-radius);
	box-shadow: var(--ds-shadow-lg);

	&__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: var(--ds-space-4) var(--ds-space-5);
		border-bottom: 1px solid var(--ds-color-border-light);
	}

	&__title {
		margin: 0;
		font-size: var(--ds-font-size-md);
		font-weight: var(--ds-font-weight-semibold);
		color: var(--ds-color-text);
	}

	&__close {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		background: none;
		border: none;
		border-radius: var(--ds-radius-xs);
		font-size: 22px;
		line-height: 1;
		color: var(--ds-color-text-muted);
		cursor: pointer;
		transition: background 0.15s;

		&:hover {
			background: var(--ds-color-bg);
			color: var(--ds-color-text);
		}
	}

	&__body {
		padding: var(--ds-space-5);
	}

	&__footer {
		display: flex;
		justify-content: flex-end;
		gap: var(--ds-space-2);
		padding: var(--ds-space-4) var(--ds-space-5);
		border-top: 1px solid var(--ds-color-border-light);
	}
}
</style>
